module.exports = __webpack_public_path__ + "static/media/preview-table-patients-cancellations.9282da2b.jpg";